import { globals } from '../../globals'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_SUBJECT_START = 'CREATE_SUBJECT_START'
export const NEW_SUBJECT_CREATED = 'NEW_SUBJECT_CREATED'
export const NEW_SUBJECT_FAILED = 'NEW_SUBJECT_FAILED'
export const NONUNIQUE_SUBJECT_NAME = 'NONUNIQUE_SUBJECT_NAME'
export const DELETE_SUBJECT_START = 'DELETE_SUBJECT_START'
export const SUBJECT_DELETED = 'SUBJECT_DELETED'
export const DELETE_SUBJECT_FAILED = 'DELETE_SUBJECT_FAILED'
export const EDIT_SUBJECT_START = 'EDIT_SUBJECT_START'
export const SUBJECT_EDITED = 'SUBJECT_EDITED'
export const EDIT_SUBJECT_FAILED = 'EDIT_SUBJECT_FAILED'
export const GET_SUBJECT_START = 'GET_SUBJECT_START'
export const SUBJECT_FETCHED = 'SUBJECT_FETCHED'
export const GET_SUBJECT_FAILED = 'GET_SUBJECT_FAILED'
export const DATA_FETCHED = 'DATA_FETCHED'
// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  'Content-Type': 'application/json'
}

export function createNewSubject (subject) {
  return (dispatch) => {
    dispatch({ type: CREATE_SUBJECT_START })
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(subject)
    }
    fetch(`${globals.apiUrl}/api/subject`, options).then((response) => {
      if (response.status === 400) {
        dispatch({ type:  NONUNIQUE_SUBJECT_NAME })
      } else if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: NEW_SUBJECT_CREATED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: NEW_SUBJECT_FAILED })
    })
  }
}

export function deleteSubject (subjectId) {
  return (dispatch) => {
    dispatch({ type: DELETE_SUBJECT_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/subject/${subjectId}`, options).then((response) => {
      if (response.status === 200) {
        dispatch({ type: SUBJECT_DELETED })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_SUBJECT_FAILED })
    })
  }
}

export function getSubject (subjectId) {
  return (dispatch) => {
    dispatch({ type: GET_SUBJECT_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/api/subject/${subjectId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: SUBJECT_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_SUBJECT_FAILED })
    })
  }
}

export function editSubject (subjectId, subject) {
  return (dispatch) => {
    dispatch({ type: EDIT_SUBJECT_START })
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(subject)
    }
    fetch(`${globals.apiUrl}/api/subject/${subjectId}`, options).then((response) => {
      if (response.status === 400) {
        dispatch({ type:  NONUNIQUE_SUBJECT_NAME })
      } else if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: SUBJECT_EDITED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: EDIT_SUBJECT_FAILED })
    })
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [DATA_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        groupNotes: {
          clientId: json.ClientId,
          userId: json.UserId
        }
      }
    }
  },
  [CREATE_SUBJECT_START] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        subjectsFetching: true,
      },
    }
  },
  [NEW_SUBJECT_CREATED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        subjectId: json,
        subjectsFetching: false,
        uniqueSubjectName: true
      }
    }
  },
  [NEW_SUBJECT_FAILED] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        subjectsFetching: false,
        uniqueSubjectName: false
      }
    }
  },
  [NONUNIQUE_SUBJECT_NAME] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        subjectsFetching: false,
        uniqueSubjectName: false,
      },
    }
  },
  [SUBJECT_EDITED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        editedSubjectResult: json,
      },
    }
  },
  [SUBJECT_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        fetchedSubject: json,
        editedSubjectResult: 0,
      },
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {}
}
export default function subjectsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/subjects.js